export const PREROLL = 'preroll';
export const MIDROLL = 'midroll';
export const POSTROLL = 'postroll';



// WEBPACK FOOTER //
// ./src/tracking/ADBPAdType.js